import { render, staticRenderFns } from "./ReportTypes.vue?vue&type=template&id=b1b8b760&"
import script from "./ReportTypes.vue?vue&type=script&lang=js&"
export * from "./ReportTypes.vue?vue&type=script&lang=js&"
import style0 from "./ReportTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports